import styled from "@mui/styled-engine-sc";

export const StyledProductImage = styled("img")`
  ${({ theme }) => `
    position: relative;
    width: 100%;
    display: block;
    //max-height: 445px;

    &.thumbnail {
      padding: ${theme.spacing(0.5)};
      border: solid 1px ${theme.palette.grey[300]};
      border-radius: ${theme.spacing(0.25)};

      &:hover {
        cursor: pointer;
      }
    }
  `}
`;

export const StyledProductImageTag = styled("div")<{ top?: string; left?: string }>`
  ${({ theme, top, left }) => `
    position: absolute;
    top: ${top || "5px"};
    left: ${left || "7px"};
    z-index: 1;

    &.static {
          position: relative;
    top: 0;
    left: 0;
        border-top-left-radius: 8px;
    }

    /* 🔥 KEY FIX */
    display: inline-flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;

    border-radius: 0 0 ${theme.spacing(2)} 0;
    padding: ${theme.spacing(2)} ${theme.spacing(3)} ${theme.spacing(2)} ${theme.spacing(3)};
    background: ${theme.palette.secondary.main};
    color: ${theme.palette.white.main};

    &.list {
      top: 0px;
      left: 0px;
      border-radius: 8px 0 8px 0;
    }

    &.promo {
      background: ${theme.palette.primary.main};
    }

     /* 🔴 Nouveau */
    &.tag-nouveau {
      background-color: #3D6881;
    }

    /* 🟡 Premier prix */
    &.tag-premier {
      background-color: #FCBB22;
      color: #000;
    }

    /* ⚫ Série Limitée */
    &.tag-limited {
      background-color: #252427;
    }

    /* 🔴 Nouveau */
    &.list.tag-nouveau {
      background-color: #3D6881;
    }

    /* 🟡 Premier prix */
    &.list.tag-premier {
      background-color: #FCBB22;
      color: #000;
    }

    /* ⚫ Série Limitée */
    &.list.tag-limited {
      background-color: #252427;
    }

    ${theme.breakpoints.down("sm")} {
      font-size: 12px;
    }

    &.list {
    background-color: #4F7C99; // existing blue
  }

  &.price-drop {
    background-color: #E1002A;
    color: #fff;

    display: inline-flex;
    align-items: center;
    gap: 6px;

    svg {
      fill: #fff;
    }
  }

  `}
`;

export const StyledProductImageLabel = styled("ul")`
  ${({ theme }) => `

    display: flex;
    width: 100%;
    list-style: none;
    gap: 20px;
    margin-top: 30px;


    li {
      margin-bottom: ${theme.spacing(1.5)};
          width: 70px;
    }
  `}
`;

export const StyledContainer = styled("div")`
  ${({ theme }) => `
    position:relative;
    border: solid 1px ${theme.palette.gray.neutralGray600};
    &::before {
      position: absolute;
      top: -5px;
      right: -1px;
      content: "";
      width: 1px;
      height: 4px;
      background-color: ${theme.palette.gray.neutralGray600};
    }
    &::after {
      position: absolute;
      top: -1px;
      right: -5px;
      content: "";
      width: 4px;
      height: 1px;
      border-bottom: 1px solid ${theme.palette.gray.neutralGray600};
    }
  `}
`;
